import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f61446d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "wrapper mb-s12"
}
const _hoisted_2 = { class: "panel-frame" }
const _hoisted_3 = { class: "sm:flex align-items-center justify-content-between mb-s2 sm:mb-s4 gutter-y-s2" }
const _hoisted_4 = { class: "h3 text-bold" }
const _hoisted_5 = { class: "mr-s1 text-sm text-link-secondary" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-chevron-right text-xs" }, null, -1))
const _hoisted_7 = { class: "carousel-wrapper" }
const _hoisted_8 = { class: "carousel" }
const _hoisted_9 = {
  key: 0,
  class: "carousel-container"
}
const _hoisted_10 = {
  key: 1,
  class: "flex align-items-stretch flex-nowrap"
}

import BigNumber from 'bignumber.js';
import { computed, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import SingleSideCarouselItem from '@/views/pages/liquidity/single-side/components/SingleSideCarouselItem.vue';
import { isMultichainToken } from '@/helpers/token.helper';
import { useSingleSideDepositTokens } from '@/views/pages/liquidity/single-side/composables/useSingleSideDepositTokens';


export default /*#__PURE__*/_defineComponent({
  __name: 'SingleSideCarousel',
  setup(__props) {

const singleSideDepositTokens = useSingleSideDepositTokens();
const { t } = useI18n();
const router = useRouter();
const { state } = useStore();
const noFeeLimit = ref(100);

const tokens = computed(() => {
  const allNotMultichainTokens = singleSideDepositTokens.tokens.value.filter(
    token => !isMultichainToken(token.portfolioToken.symbol ?? ''),
  );
  const carouselItems = allNotMultichainTokens.filter(token =>
    token.noFeeLimitInUSD.gte(BigNumber(noFeeLimit.value)),
  );
  return (carouselItems.length >= 4 ? carouselItems : allNotMultichainTokens)
    .sort((prev, next) => next.apr.minus(prev.apr).toNumber())
    .slice(0, 10);
});

const isLoadedTokens = computed(() => {
  return !singleSideDepositTokens.isLoadingTokens.value;
});

const isShowCarousel = computed(() => {
  if (!isLoadedTokens.value) return true;

  return tokens.value.length > 0;
});

const isSmallTokensLength = computed(() => {
  if (state.layout.isDesktop) return tokens.value.length < 4;
  if (state.layout.isTablet) return tokens.value.length < 3;
  return false;
});

const slidingTime = computed(() => `animation-duration: ${8 * tokens.value.length}s`);

const goToSingleSide = () => router.push('/single-side');

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_Skeleton = _resolveComponent("Skeleton")!

  return (_unref(isShowCarousel))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('singleSide.header')), 1),
            _createElementVNode("div", null, [
              _createVNode(_component_Button, {
                class: "button-text",
                onClick: goToSingleSide
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(t)('singleSide.moreTokens')), 1),
                  _hoisted_6
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              (_unref(isLoadedTokens))
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("div", {
                      class: "carousel-items",
                      style: _normalizeStyle(_unref(slidingTime))
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tokens), (token) => {
                        return (_openBlock(), _createBlock(SingleSideCarouselItem, {
                          token: token,
                          key: token.id
                        }, null, 8, ["token"]))
                      }), 128))
                    ], 4),
                    _createElementVNode("div", {
                      class: "carousel-items",
                      style: _normalizeStyle(_unref(slidingTime))
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tokens), (token) => {
                        return (_openBlock(), _createBlock(SingleSideCarouselItem, {
                          token: token,
                          key: token.id
                        }, null, 8, ["token"]))
                      }), 128))
                    ], 4),
                    (_unref(isSmallTokensLength))
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "carousel-items",
                          style: _normalizeStyle(_unref(slidingTime))
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tokens), (token) => {
                            return (_openBlock(), _createBlock(SingleSideCarouselItem, {
                              token: token,
                              key: token.id
                            }, null, 8, ["token"]))
                          }), 128))
                        ], 4))
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (n) => {
                      return _createElementVNode("div", {
                        class: "carousel-item ml-s3",
                        key: n
                      }, [
                        _createVNode(_component_Skeleton, {
                          width: "300px",
                          height: "126px"
                        })
                      ])
                    }), 64))
                  ]))
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})